import {
	getGoodsDetail,
	getSuppliersAll,
	goodsup
} from '@/api/goods.js';
import Cookies from 'js-cookie'
import Pagination from '@/components/Pagination';
export default {
	name: 'framework',
	components: {
		Pagination
	},

	data() {
		return {
			orderObj: { //订单列表
				info: [],
				listLoading: false,
			},
			token: '',
			editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
            ['blockquote', 'code-block'], // 引用  代码块
            [{ header: 1 }, { header: 2 }], // 1、2 级标题
            [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
            [{ script: 'sub' }, { script: 'super' }], // 上标/下标
            [{ indent: '-1' }, { indent: '+1' }], // 缩进
            [{ direction: 'rtl' }], // 文本方向
            [{ size: ['12', '14', '16', '18', '20', '22', '24', '28', '32', '36'] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6] }], // 标题
            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
            // [{ font: ['songti'] }], // 字体种类
            [{ align: [] }], // 对齐方式
            ['clean'], // 清除文本格式
            ['image', 'video'] // 链接、图片、视频
          ]
        },
        placeholder: '请输入正文'
      },
			supplierList: [],
			telnoTypeList: [
				{
					value: 1,
					label: '移动'
				},
				{
					value: 2,
					label: '联通'
				},
				{
					value: 3,
					label: '电信'
				}
			],
			action: '',
			imageUrl1: '',
			imageUrl2: '',
			attachPath: '/ssycfile'
		}
	},
	filters: {
		statusFilter(type) { //状态
			return {
				1:'下架',
				0:'上架'
			}[type]
		},
	},
	created() {
		this.getGoodsDetail(this.$route.query.id)
		this.action =`${process.env.VUE_APP_BASE_API}admin/goods/upload-goods-pic`
	},
	methods: {
		// 更新
		onSubmit(){
			goodsup(this.orderObj.info).then(res=>{
				console.log(res)
				if (res.code == 200) {
					this.$message.success(res.message);
					// this.getGoodsDetail(this.orderObj.info.id)
					setTimeout(function(){
						location.reload();
					}, 1000)
				}
			})
		},
		goBack() {
			this.$router.go(-1)
		},
		//获取订单详情
		getGoodsDetail(id) {
			let _this = this;
			this.orderObj.listLoading = true;
			this.token =  Cookies.get('token');
			//获取订单列表
			getGoodsDetail({goodsId: id}).then(res => {
				this.imageUrl1 = this.attachPath + res.data.picUrl
				this.imageUrl2 = this.attachPath + res.data.detailPicUrl
				_this.orderObj.info = res.data;
				_this.orderObj.listLoading = false;
			})
			getSuppliersAll({}).then(res => {
				console.log(res.data)
				_this.supplierList = res.data;
			})
		},
		addSkuToList(row) {
			let _this = this;
			const goods = {
				supplierProductSn: '',
				specification: '',
				number: '',
				goodsProcurementPrice: '',
				costPrice: '',
				sharePrice: '',
				platformPrice: '',
				facePrice: '',
				status: 1,
			}
			_this.orderObj.info.goodsProductList.push(goods);
		},
		//变更sku 上下架状态
		changeProductStatus(row, index) {
			let status = row.status == 1 ? 0 : 1
			this.orderObj.info.goodsProductList[index].status = status
		},
		handleAvatarSuccess(res) {
			this.imageUrl1 = this.attachPath + res.data
			this.orderObj.info.picUrl = res.data
		},
		handleAvatarSuccess2(res) {
			this.imageUrl2 = this.attachPath + res.data
			this.orderObj.info.detailPicUrl = res.data
		},
	}
}
